import { ArrowRight, Check } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { PageMeta } from "@/components/PageMeta";
import { siteContent } from "@/data/siteContent";

const CopyBlock = ({ lines, testId }) => (
  <div className="start-page-copy" data-testid={testId}>{lines.map((line) => <p key={line}>{line}</p>)}</div>
);

export default function StartHerePage() {
  const page = siteContent.startHerePage;

  return (
    <div className="site-shell" data-testid="start-here-page">
      <PageMeta {...page.meta} />
      <a className="skip-link" href="#main-content" data-testid="skip-to-content-link">Skip to content</a>
      <SiteHeader />
      <main id="main-content">
        <section className="start-page-hero" aria-labelledby="start-page-title" data-testid="start-page-hero">
          <div className="site-container">
            <p className="section-kicker" data-testid="start-page-kicker">{page.hero.kicker}</p>
            <h1 id="start-page-title" className="display-title start-page-title" data-testid="start-page-title">{page.hero.heading}</h1>
            <CopyBlock lines={page.hero.copy} testId="start-page-hero-copy" />
            <div className="hero-context start-page-topics" data-testid="start-page-topics">{page.hero.topics.map((topic) => <span key={topic}>{topic}</span>)}</div>
          </div>
        </section>

        <section className="start-page-section section-shell--paper" aria-labelledby="start-intro-title" data-testid="start-page-introduction">
          <div className="site-container start-page-reading">
            <h2 id="start-intro-title" className="section-title">{page.introduction.heading}</h2>
            <CopyBlock lines={page.introduction.copy} testId="start-introduction-copy" />
          </div>
        </section>

        <section className="start-page-section section-shell--teal" aria-labelledby="start-journey-title" data-testid="start-page-journey">
          <div className="site-container start-page-reading">
            <h2 id="start-journey-title" className="section-title">{page.journey.heading}</h2>
            <CopyBlock lines={page.journey.copy} testId="start-journey-copy" />
          </div>
        </section>

        <section className="start-page-section" aria-labelledby="start-explore-title" data-testid="start-page-explore">
          <div className="site-container start-page-split">
            <div>
              <h2 id="start-explore-title" className="section-title">{page.explore.heading}</h2>
              <p className="section-intro">{page.explore.copy}</p>
            </div>
            <div>
              <ul className="start-page-list">{page.explore.items.map((item) => <li key={item}><Check size={18} aria-hidden="true" />{item}</li>)}</ul>
              <CopyBlock lines={page.explore.closing} testId="start-explore-closing" />
            </div>
          </div>
        </section>

        <section className="start-page-section section-shell--paper" aria-labelledby="start-boundary-title" data-testid="start-page-boundaries">
          <div className="site-container start-page-reading">
            <h2 id="start-boundary-title" className="section-title">{page.boundaries.heading}</h2>
            <CopyBlock lines={page.boundaries.copy} testId="start-boundary-copy" />
          </div>
        </section>

        <section className="start-page-cta start-page-cta--webinar" aria-labelledby="webinar-title" data-testid="free-webinar-section">
          <div className="site-container start-page-reading">
            <h2 id="webinar-title" className="section-title">{page.webinar.heading}</h2>
            <p>{page.webinar.copy}</p>
            <a className="secondary-action-button" href={page.webinar.cta.destination} data-testid="free-webinar-cta">{page.webinar.cta.label}<ArrowRight size={17} aria-hidden="true" /></a>
          </div>
        </section>

        <section className="start-page-cta start-page-cta--paid" aria-labelledby="paid-title" data-testid="paid-shakthi-section">
          <div className="site-container start-page-reading">
            <p className="section-kicker">{page.paid.supportingLine}</p>
            <h2 id="paid-title" className="section-title">{page.paid.heading}</h2>
            <p>{page.paid.copy}</p>
            <a className="primary-link" href={page.paid.cta.destination} data-testid="paid-shakthi-cta">{page.paid.cta.label}<ArrowRight size={17} aria-hidden="true" /></a>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}